import { render, staticRenderFns } from "./ThgBillingSelectionItemRegistrationImage.vue?vue&type=template&id=0c800a6f&"
import script from "./ThgBillingSelectionItemRegistrationImage.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionItemRegistrationImage.vue?vue&type=script&lang=ts&"
import style0 from "./ThgBillingSelectionItemRegistrationImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardActions,VImg,VTooltip})
